import { adminHttpErrorRenderer } from './admin_http_error'
import { defaultRenderer } from './default'
import { featureAnnouncementRenderer } from './feature_announcement'
import { protocolMovedRenderer } from './protocol_moved'
import type { NotificationRenderer } from './types'

/**
 * Registry por `type_id`. Cada entrada decide como aquele tipo aparece em
 * Preview (popover/lista) e Full (página/modal).
 *
 * Pra adicionar um tipo:
 *   1. crie `renderers/<type_id>.tsx` exportando um `NotificationRenderer`
 *   2. registre aqui
 *
 * Tipo sem entrada cai no `defaultRenderer` (title + body), então o back pode
 * lançar tipos novos sem quebrar o front.
 */
const REGISTRY: Record<string, NotificationRenderer> = {
  protocol_moved: protocolMovedRenderer,
  // Os dois tipos carregam `error_log_id` no context e usam o mesmo renderer. O `user_http_error`
  // vai pro usuário que SOFREU o erro, que quase nunca tem `admin:logs:read` — ali o botão não
  // aparece, e é isso que se espera. O renderer ramifica pelo `type_id`: exceção, rota e status só
  // saem no `admin_http_error` (`ehDetalheTecnico`).
  admin_http_error: adminHttpErrorRenderer,
  user_http_error: adminHttpErrorRenderer,
  // `kind: 'marketing'`; o conteúdo rico vem do catálogo local por `feature_key`.
  feature_announcement: featureAnnouncementRenderer,
}

export function getRenderer(typeId: string): NotificationRenderer {
  return REGISTRY[typeId] ?? defaultRenderer
}

export { defaultRenderer, protocolMovedRenderer, adminHttpErrorRenderer, featureAnnouncementRenderer }
export type { NotificationRenderer, NotificationViewProps } from './types'
